/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Complete_CtaInputs */

const en_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Dashboard`)
};

const de_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Dashboard gehen`)
};

const fr_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au tableau de bord`)
};

const es_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al panel`)
};

const it_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai al Dashboard`)
};

const nl_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar Dashboard`)
};

const pl_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do pulpitu nawigacyjnego`)
};

const fi_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mene Hallintapaneeliin`)
};

const da_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til Dashboard`)
};

const sv_onboarding_complete_cta = /** @type {(inputs: Onboarding_Complete_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå till instrumentpanel`)
};

/**
* | output |
* | --- |
* | "Go to Dashboard" |
*
* @param {Onboarding_Complete_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_complete_cta = /** @type {((inputs?: Onboarding_Complete_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Complete_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_complete_cta(inputs)
	if (locale === "fr") return fr_onboarding_complete_cta(inputs)
	if (locale === "es") return es_onboarding_complete_cta(inputs)
	if (locale === "it") return it_onboarding_complete_cta(inputs)
	if (locale === "nl") return nl_onboarding_complete_cta(inputs)
	if (locale === "pl") return pl_onboarding_complete_cta(inputs)
	if (locale === "fi") return fi_onboarding_complete_cta(inputs)
	if (locale === "da") return da_onboarding_complete_cta(inputs)
	if (locale === "sv") return sv_onboarding_complete_cta(inputs)
	return en_onboarding_complete_cta(inputs)
});